export const Permissions = {
    airspaces: {
        route: "/airspaces",
        hasPermission: (user) => isNotFirstResponder(user)
    },
    chat: {
        route: "/chat",
        hasPermission: (user) => isNotFirstResponder(user)
    },
    counterUAS: {
        route: "/asset-map",
        hasPermission: (user) => hasAnyRole(user, "Admin", "Airspace Manager") && hasService(user, "COUNTER_UAS")
    },
    infrastructure: {
        route: "/infrastructure",
        hasPermission: (user) => hasAnyRole(user, "Admin") && hasService(user, "INFRASTRUCTURE")
    },
    opManagerDashboard: {
        route: "/op-manager-dashboard",
        hasPermission: (user) => hasAnyRole(user, "Admin", "Operations Manager", "Admin - Org") && hasService(user, "OP_MANAGER_DASHBOARD")
    },
    settings: {
        hasPermission: (user) => isNotFirstResponder(user)
    },
    hms: {
        route: "/hms",
        hasPermission: (user) => isNotFirstResponder(user)
    },
    hmsSettings: {
        route: "/hms-settings",
        hasPermission: (user) => hasAnyRole(user, "Admin", "Airspace Manager")
    },
    zcaSettings: {
        route: "/zca-settings",
        hasPermission: (user) => hasAnyRole(user, "Admin", "Airspace Manager", "Operations Manager")
    },
    analysis: {
        route: "/analysis",
        hasPermission: (user, dataLoggingOn) =>
            hasAnyRole(user, "Admin", "Airspace Manager", "Operations Manager", "Operator", "Admin - Org") && dataLoggingOn === "true"
    },
    manageUsers: {
        route: "/manage",
        hasPermission: (user) => hasAnyRole(user, "Admin", "Admin - Org")
    },
    manageOrganizations: {
        route: "/organizations",
        hasPermission: (user) => isAdmin(user)
    },
    datalogs: {
        route: "/datalogs",
        hasPermission: (user) => isAdmin(user)
    },
    monitoring: {
        route: "/monitoring",
        hasPermission: (user, dataLoggingOn) => isAdmin(user) && dataLoggingOn === "true"
    },
    playback: {
        route: "/playback",
        hasPermission: (user) => isAdmin(user) && hasService(user, "PLAYBACK")
    },
    feedback: {
        route: "/feedback",
        hasPermission: (user, feedbackFormEnabled) => isAdmin(user) && feedbackFormEnabled
    }
};

function hasRole(user, role) {
    return hasAnyRole(user, role);
}

function hasAnyRole(user, ...roles) {
    for (const role of roles) {
        if (user.user_role === role) {
            return true;
        }
    }
    return false;
}

function hasService(user, serviceName) {
    return !!user.services?.includes(serviceName);
}

// Commonly called roles below.
function isAdmin(user) {
    return hasRole(user, "Admin");
}

function isNotFirstResponder(user) {
    return !hasRole(user, "First Responder");
}
